import { Component, EventEmitter, Output, Input } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmationService } from 'src/app/shared/services';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
})
export class LanguageComponent {
  @Output() valueChange = new EventEmitter<any>();
  @Input() value: string = this.config.getDefaultLocale();
  // `lang` zeichnet die Sprache des Labels aus, damit ein Screenreader die Option
  // korrekt ausspricht (WCAG 2.2 SC 3.1.2).
  //
  // `sw` ist bewusst gesetzt und nicht `en`: das Locale wird nachgelagert
  // durchgehend als `lang="sw"` gebraucht, `id` und `lang` sollen dafür nicht
  // auseinanderlaufen.
  //
  // Optimal wäre zusätzlich der native Name "Kiswahili" -- dann wäre die
  // Auszeichnung auch sprachlich korrekt. "Swahili" ist der englische Name und
  // wird hier mit Swahili-Aussprache vorgelesen; bewusst in Kauf genommen.
  // "English"/"Deutsch" sind ohnehin die nativen Namen.
  languages = [
    { id: 'en', name: 'English', lang: 'en' },
    { id: 'de', name: 'Deutsch', lang: 'de' },
    { id: 'sw', name: 'Swahili', lang: 'sw' },
  ];

  constructor(private config: ConfigService, private confirmationService: ConfirmationService) {}

  modelChanged() {
    this.confirmationService.setDataUpdated();
    this.valueChange.emit(this.value);
  }
}
